module.exports = __webpack_public_path__ + "static/img/training_system_s1_max.ed0d032f.png";